document.addEventListener('DOMContentLoaded', function() {
    const branchSearch = document.getElementById('branch-search');
    if (!branchSearch) {
        return;
    }

    const count = document.getElementById('branch-count');
    const noResult = document.getElementById('branch-no-result');

    branchSearch.addEventListener('input', function() {
        var keyword = this.value.trim().toLowerCase();
        var visibleCount = 0;
        var items = document.querySelectorAll('#branch-list .branch-item');
        items.forEach(function(item) {
            var name = item.getAttribute('data-name').toLowerCase();
            if (name.indexOf(keyword) !== -1) {
                item.style.display = '';
                visibleCount++;
            } else {
                item.style.display = 'none';
            }
        });

        if (count) {
            count.textContent = visibleCount;
        }
        if (noResult) {
            noResult.classList.toggle('hidden', visibleCount > 0);
        }
    });
});

// 支部編集画面: 紐づけ対象ユーザーグループの名前絞り込み
document.addEventListener('DOMContentLoaded', function() {
    const userGroupSearch = document.getElementById('user-group-search');
    if (!userGroupSearch) {
        return;
    }

    userGroupSearch.addEventListener('input', function() {
        var keyword = this.value.trim().toLowerCase();
        var items = document.querySelectorAll('#user-group-list .user-group-item');
        items.forEach(function(item) {
            var name = item.getAttribute('data-name').toLowerCase();
            item.style.display = name.indexOf(keyword) !== -1 ? '' : 'none';
        });
    });
});
